import { jsx as _jsx } from "react/jsx-runtime";
import { Switch } from "@faire/web--source/ui/routing/Switch";
import { observer } from "mobx-react";
import React, { Suspense } from "react";
import { Redirect } from "react-router-dom";
import * as RetailerPaths from "@faire/retailer-visitor-shared/paths/index";
var MarketBrandDirectoryRouterBase = function() {
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/ _jsx(Switch, {
            children: /*#__PURE__*/ _jsx(Redirect, {
                to: RetailerPaths.home()
            })
        })
    });
};
export var MarketBrandDirectoryRouter = observer(MarketBrandDirectoryRouterBase);
